<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-user-circle"></i> Students</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
              <router-link v-bind:to="{name: 'add-student' }" class="button is-info is-pulled-right">Add new</router-link>
            </div>
            <div class="column">
                <students-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="students" v-bind:actions="true"></students-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import StudentRepo from '../../repos/StudentRepo'
import lodash from 'lodash'
import StudentsTable from "./Table";

export default {
  name: 'students-view',
  components: {StudentsTable},
  data() {
        return {
            repo: new StudentRepo(this.$auth),
            students: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getStudents();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getStudents();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getStudents();
    },
    onPageChanged(page){
        this.page = page;        
        this.getStudents();
    },
    getStudents(){
        this.repo.paginate(this.page, this.q, this.orderBy).then(response => {            
            this.students = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/students/View.vue